import { apiGet } from './api';

export type NavCounts = {
  counts: Record<string, number>;
  alert: Record<string, boolean>;
  onec: boolean;
};

export const getNavCounts = () => apiGet<NavCounts>('/api/nav/counts');
